import { GetTransferToken } from '../utils/authFunctions';
const DIGITAL_FORM_URL = window.__ENV__.DIGITAL_FORM_URL;
const DIGITAL_FORM_ROUTE = window.__ENV__.DIGITAL_FORM_ROUTE;

export default class StepUpCallbackHandler {
  // Add logger?
  async callbackHandler(jwt, sessionCorrelationId, formName, lang) {

    if (!jwt || !formName) {
      throw new Error('JWT or formName undefined');
    }

    const response = await GetTransferToken(jwt, sessionCorrelationId);
    const responseBody = await response.json();

    if (response.status === 200) {
      const transferToken = responseBody['gb-transfer-token'];

      let urlText = `${DIGITAL_FORM_URL}/${transferToken}/${DIGITAL_FORM_ROUTE}/`;

      if (lang === 'fr-CA') {
        urlText += `fr/${formName}`;
      } else {
        urlText += `en/${formName}`;
      }

      window.open(urlText, '_self');
    }
  }
}
